import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.66699 11.3333L11.3337 4.66666M11.3337 4.66666H4.66699M11.3337 4.66666V11.3333", stroke: "currentColor", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowUpRight);
export { ForwardRef as ReactComponent };
